import React from "react"
import styled from "styled-components"

const StyledDiv = styled.div`
  width: 60rem;
  display: block;
  padding: 2rem 4rem;
`
export const Detail: React.FC = ({ children, ...props }) => {
  return <StyledDiv {...props}>{children}</StyledDiv>
}
